import '../../../components/group/group-add-membership-modal/group-add-membership-modal.module';

import * as angular from 'angular';

import { GroupConnectionsBrowserComponent } from '../../group/group-connections-browser/group-connections-browser.component';
import { GroupMembersBrowserComponent } from '../../group/group-members-browser/group-members-browser.component';
import { GroupSpacesBrowserComponent } from '../../group/group-spaces-browser/group-spaces-browser.component';
import { GroupsBrowserComponent } from '../groups-browser/groups-browser.component';
import { GroupsPanelComponent } from './groups-panel.component';
import { GroupsPanelRoutesConfig } from './groups-panel.routes';

// TODO (Franklin) 4/14/2020: Retire this {@link GroupsPanelModule} and move routes
//  to {@link GroupsModule} and {@link GroupModule} respectively
angular
  .module('groups-panel', ['group-add-membership-modal'])
  .config(GroupsPanelRoutesConfig)
  .component('groupsBrowser', GroupsBrowserComponent)
  .component('groupMembersBrowser', GroupMembersBrowserComponent)
  .component('groupSpacesBrowser', GroupSpacesBrowserComponent)
  .component('groupConnectionsBrowser', GroupConnectionsBrowserComponent)
  .component('groupsPanel', GroupsPanelComponent);
